import { render, staticRenderFns } from "./RelationsCytoscape.vue?vue&type=template&id=54ca9402"
import script from "./RelationsCytoscape.vue?vue&type=script&lang=js"
export * from "./RelationsCytoscape.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports